import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const Container = styled('div')(
  {
    alignItems: 'center',
    borderRadius: 5,
    display: 'inline-flex',
    height: 59,
    justifyContent: 'center',
    marginRight: 9,
    overflow: 'hidden',
    width: 71,
    [media('xs')]: {
      zIndex: 1,
      position: 'absolute',
      top: -30
    },
    [media('lg')]: {
      position: 'initial'
    }
  },
  ({ theme }) => ({
    border: `1px solid ${theme.palette.colors.columbiaBlue}`,
    backgroundColor: theme.palette.colors.white
  })
);

export default Container;
